import {
  setCurrentUser,
  setUserList,
  addUserNew,
  setSingleCurrentUser,
  setMostFrequentUsers,
  setMostFrequentEditor,
  setMostFrequentScriptWriter,
  setMostFrequentAnchor,
  setMostFrequentCameraman,
  setMostFrequentContentType,
  setMostFrequentCategory,
  setMostFrequentSocial,
  setMostFrequentDenmark,
  setLogoutStatus,
  setUserBunchList,
  setCreateBucketOrder,
} from "./user.slice";
import { RootState } from "..";
import { Dispatch } from "redux";
import {
  AddUserApi,
  GetUserApi,
  ListUserApi,
  ApproveUserApi,
  RejectUserApi,
  UpdateUserApi,
  UserGetParamsBody,
  UserModel,
  UsersListParamsBody,
  MostFrequentUserApi,
  MostFrequentUserApiNoIndex,
  LogoutApi,
  ServiceRequestApi,
  GetUserSettingsApi,
  GetMeApi,
  MostFrequentUserApiAll,
} from "@/database";
import { GetUserPreferenceApi } from "@/database/user/api";
import { GetUserBucketListApi } from "@/database/Upload/api";
import { setAdminBucketList } from "@/store/media/media.slice";
import { getChangedValues } from "@/components/CleoPlayer/utils";
import { logout, setUser } from "../auth/auth.slice";
import { toast } from "../../components";

export type Response<T> = {
  data?: T;
  isLoading?: boolean;
  error?: string | null;
};

export type UserListAction = Response<{
  list: UserModel[];
  count: number;
}>;

export const getListUser =
  (params: UsersListParamsBody) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setUserList({ isLoading: true }));

    const response = await ListUserApi(params);
    if (params?.setInRedux !== false) {
      dispatch(
        setUserList({
          data: { list: response.data, count: response.count },
          error: response.error,
          isLoading: false,
        })
      );
    }
    return response.data;
  };

export const getListUserBunch =
  (params: UsersListParamsBody) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    const response = await ListUserApi(params);
    if (response.status === 200) {
      dispatch(
        setUserBunchList({
          data: { list: response.data, count: response.count },
          error: response.error,
          isLoading: false,
        })
      );
    } else {
      dispatch(
        setUserBunchList({
          data: { list: [], count: 0 },
          error: response.error,
          isLoading: false,
        })
      );
    }
    return response.data;
  };

export const getMostFrequentUsers =
  (params: UserGetParamsBody) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setMostFrequentUsers({ isLoading: true }));
    const response = await MostFrequentUserApi(params);

    if (params.key === "producer") {
      dispatch(
        setMostFrequentUsers({
          data: { list: response.data, count: response?.count },
          error: response.error,
          isLoading: false,
        })
      );
    } else if (params.key === "editor") {
      dispatch(
        setMostFrequentEditor({
          data: { list: response.data, count: response?.count },
          error: response.error,
          isLoading: false,
        })
      );
    } else if (params.key === "script_writer") {
      dispatch(
        setMostFrequentScriptWriter({
          data: { list: response.data, count: response?.count },
          error: response.error,
          isLoading: false,
        })
      );
    } else if (params.key === "anchor") {
      dispatch(
        setMostFrequentAnchor({
          data: { list: response.data, count: response?.count },
          error: response.error,
          isLoading: false,
        })
      );
    } else if (params.key === "cameraman") {
      dispatch(
        setMostFrequentCameraman({
          data: { list: response.data, count: response?.count },
          error: response.error,
          isLoading: false,
        })
      );
    }
  };

export const getMostFrequentNoIndex =
  (params: UserGetParamsBody) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setMostFrequentUsers({ isLoading: true }));
    const response = await MostFrequentUserApiNoIndex(params);

    if (params.key === "ctype") {
      dispatch(
        setMostFrequentContentType({
          data: { list: response.data, count: response?.count },
          error: response.error,
          isLoading: false,
        })
      );
    } else if (params.key === "category") {
      dispatch(
        setMostFrequentCategory({
          data: { list: response.data, count: response?.count },
          error: response.error,
          isLoading: false,
        })
      );
    } else if (params.key === "social") {
      dispatch(
        setMostFrequentSocial({
          data: { list: response.data, count: response?.count },
          error: response.error,
          isLoading: false,
        })
      );
    } else if (params.key === "denmark") {
      dispatch(
        setMostFrequentDenmark({
          isLoading: false,
          list: response.data,
          error: response.error,
        })
      );
    }
  };

const convertToModel = (data: any) => {
  return data.map((item: any) => {
    return { id: item, name: item };
  });
};

export const getMostFrequentAll =
  (params: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setMostFrequentUsers({ isLoading: true }));
    const response = await MostFrequentUserApiAll(params);

    if (response.error === "") {
      if (response?.data?.result?.ctype) {
        dispatch(
          setMostFrequentContentType({
            isLoading: false,
            data: {
              list: convertToModel(response.data.result.ctype),
              count: response?.count,
            },
            error: response.error,
          })
        );
      }
      if (response?.data?.result?.category) {
        dispatch(
          setMostFrequentCategory({
            isLoading: false,
            data: {
              list: convertToModel(response.data.result.category),
              count: response?.count,
            },
            error: response.error,
          })
        );
      }
      if (response?.data?.result?.producer) {
        dispatch(
          setMostFrequentUsers({
            isLoading: false,
            data: {
              list: convertToModel(response.data.result.producer),
              count: response?.count,
            },
            error: response.error,
          })
        );
      }
      if (response?.data?.result?.editor) {
        dispatch(
          setMostFrequentEditor({
            isLoading: false,
            data: {
              list: convertToModel(response.data.result.editor),
              count: response?.count,
            },
            error: response.error,
          })
        );
      }
      if (response?.data?.result?.anchor) {
        dispatch(
          setMostFrequentAnchor({
            isLoading: false,
            data: {
              list: convertToModel(response.data.result.anchor),
              count: response?.count,
            },
            error: response.error,
          })
        );
      }
      if (response?.data?.result?.cameraman) {
        dispatch(
          setMostFrequentCameraman({
            isLoading: false,
            data: {
              list: convertToModel(response.data.result.cameraman),
              count: response?.count,
            },
            error: response.error,
          })
        );
      }
      if (response?.data?.result?.denmark) {
        dispatch(
          setMostFrequentDenmark({
            isLoading: false,
            list: response.data.result.denmark,
            count: response?.count,
            error: response.error,
          })
        );
      }
    }
  };

export const getCurrentUser =
  (params: UserGetParamsBody) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setCurrentUser(null));
    const response = await GetUserApi(params);
    dispatch(setCurrentUser(response.data));
  };

export const getSingleCurrentUser =
  () => async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setSingleCurrentUser(null));
    const response = await GetMeApi();

    if (response.status === 200) {
      dispatch(
        setSingleCurrentUser({
          data: { list: [response.data], count: 1 },
          error: response.error,
          isLoading: false,
        })
      );
      dispatch(setUser({ isLoggedIn: true, ...response.data }));
      const defaultTeam = response.data.default_team;
      Promise.all([
        GetUserPreferenceApi(),
        defaultTeam ? GetUserBucketListApi({ team: defaultTeam, status: 1 }) : Promise.resolve(null),
      ]).then(([prefRes, bucketRes]) => {
        const order = prefRes?.data?.create_bucket?.order;
        dispatch(setCreateBucketOrder(Array.isArray(order) && order.length > 0 ? order : null));
        if (bucketRes?.status === 200) {
          dispatch(setAdminBucketList({ data: { list: bucketRes.data.list }, isLoading: false }));
        } else {
          dispatch(setAdminBucketList({ data: { list: [] }, isLoading: false }));
        }
      }).catch(() => {
        dispatch(setCreateBucketOrder(null));
        dispatch(setAdminBucketList({ data: { list: [] }, isLoading: false }));
      });
    } else if (response.status === 401) {
      throw new Error(response.error || "Failed to update media");
    } else {
      dispatch(setCurrentUser(null));
      dispatch(
        setSingleCurrentUser({
          data: { list: [], count: 0 },
          error: response.error,
          isLoading: false,
        })
      );
    }
  };

export const refreshCurrentUser =
  () => async (dispatch: Dispatch, getState: () => RootState) => {
    const response = await GetMeApi();

    if (response.status === 200) {
      dispatch(
        setSingleCurrentUser({
          data: { list: [response.data], count: 1 },
          error: response.error,
          isLoading: false,
        })
      );
    }
  };

export const updateUser =
  (params: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    // dispatch(setCurrentUser(null));
    const currentUser = getState().users.currentUser;
    let finalUserDetails = {};
    if (!params.ftp) {
      finalUserDetails = getChangedValues(currentUser, params);
    } else {
      finalUserDetails = params;
    }
    // const finalUserDetails = getChangedValues(currentUser, params);

    const final2 = { ...finalUserDetails, id: currentUser?.id };
    const response = await UpdateUserApi(final2);
    // dispatch(setCurrentUser(response.data));
    if (!response.error) {
      toast.success("User updated successfully");
    } else {
      if (response?.error?.includes("unique constraint failed")) {
        toast.fail("User with this email already exists");
      } else {
        toast.fail("");
      }
    }
  };

export const editUserUpdate =
  (params: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    const response = await UpdateUserApi(params);
    const userList = getState().users.userList;
    const updatedUserList = userList.list.map((user: any) => {
      if (user.id === params.id) {
        // Merge the response data with existing user data to preserve all fields
        return { ...user, ...response.data };
      }
      return user;
    });
    if (!response.error) {
      // Update the user list with the merged data
      dispatch(
        setUserList({
          data: { list: updatedUserList, count: userList.count },
          error: null,
          isLoading: false,
        })
      );
      toast.success("User updated successfully");
    } else {
      toast.fail("");
    }
  };

export const addUser =
  (params: any, callback?: any) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    try {
      const response = await AddUserApi(params);
      if (!response.error) {
        if (callback) {
          callback();
        }
        dispatch(addUserNew(response.data));
      } else {
        if (response?.error?.includes("unique constraint failed")) {
          toast.fail("User with this email already exists");
        } else {
          toast.fail("");
        }
      }
    } catch (error) {
      toast.fail("");
    }
  };

export const approveUser =
  (params: any, onClose?: any) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    const response = await ApproveUserApi(params);
    if (!response.error) {
      onClose();
      toast.success("User approved successfully");
    } else {
      toast.fail("");
    }
  };

export const rejectUser =
  (params: any, onClose?: any) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    const response = await RejectUserApi(params);
    if (!response.error) {
      onClose();
      toast.success("User rejected successfully");
    } else {
      toast.fail("");
    }
  };

export const UserReject =
  (params: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    const response = await RejectUserApi(params);
    if (!response.error) {
      toast.success("User rejected successfully");
    } else {
      toast.fail("");
    }
    return response;
  };

export const getUserSettings =
  (params: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    const response = await GetUserSettingsApi(params);

    if (!response.error) {
      // dispatch(setUserSettings({ isLoading: false, data: response.data, error: response.error }));
      const currentSingleUser = getState().users.singleCurrentUser;

      if (currentSingleUser) {
        const updatedUserSettings = {
          ...currentSingleUser.user_settings?.[0],
          favorites: {
            ...currentSingleUser.user_settings?.[0]?.favorites,
            discover: response.data?.settings?.favorites?.discover,
          },
        };

        dispatch(
          setSingleCurrentUser({
            isLoading: false,
            data: {
              list: [
                { ...currentSingleUser, user_settings: [updatedUserSettings] },
              ],
              count: 1,
            },
            error: response.error,
          })
        );
      }
    }
  };

export const UserApprove =
  (params: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    const response = await ApproveUserApi(params);
    if (!response.error) {
      toast.success("User approved successfully");
    } else {
      toast.fail("");
    }
    return response;
  };

export const ServiceRequest =
  (params: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    const response = await ServiceRequestApi(params);
    if (!response.error) {
      toast.success("Service request submitted successfully");
    } else {
      toast.fail("");
    }
  };

export const logoutUser =
  (params: any) => async (dispatch: Dispatch, getState: () => RootState) => {
    const userId =
      getState().users.currentUser?.id ||
      getState().users.singleCurrentUser?.id;
    try {
      const response = await LogoutApi({
        type: params.type ?? "current",
        id: params.id,
        userid: userId,
      });
      if (!response.error) {
        if (params.type === "current" || params.type === "everywhere") {
          dispatch(logout(""));
          window.location.href = "/";
        }
        dispatch(setLogoutStatus({ isLoading: false, error: null }));
      } else {
        dispatch(setLogoutStatus({ isLoading: false, error: response.error }));
      }
    } catch {
      dispatch(setLogoutStatus({ isLoading: false, error: "Logout failed" }));
    }
  };
